import { number } from 'yup'
import { safify } from '../utils/safify'

export const brandVisualKitId = number()
  .positive()
  .integer()
  .meta({ label: 'Use your brand styles', autoFill: true, featureFlags: { brand_kits: false } })
  .transform(safify)
